module.exports = __webpack_public_path__ + "img/law3-m@1.63d4d466.jpg";